import script from "./Booking.vue?vue&type=script&setup=true&lang=js"
export * from "./Booking.vue?vue&type=script&setup=true&lang=js"

import "./Booking.vue?vue&type=style&index=0&id=7a0de6b0&scoped=true&lang=scss"
script.__scopeId = "data-v-7a0de6b0"

export default script